const HELP_TEXTS = {
  info: {
    created:
      'This date represents when the merchant became eligible to create campaigns on zDirect',
  },
};

export default HELP_TEXTS;
